export const LANGUAGES = ["en-US", "zh-TW"];
